module.exports = __webpack_public_path__ + "fonts/enterprisePortal.06fe6d3.eot";